export default class Draggable {
    constructor(elem, options){
        this.elem = elem
        this.debounceTime = 50
        this.handlers = []
        this.startX
        this.startY
        this.dragTargets = options.dragTargets || []
        //this.dragTargets = ['pcr-app', 'pcr-swatches']
    }


    init(){
        this.addEvent('mousedown', this.onMouseDown.bind(this));
        this.addEvent('touchstart', this.onMouseDown.bind(this));
        this.setCursorStyle('grab');
    }

    onMouseDown(e){
        //Check target to see if this starts
        //Maybe add it in options
        if(this.blockTarget(e)){
            return
        }
        e.preventDefault();

        this.setCursorStyle('grabbing');

        this.removeEvent('mousedown');
        this.removeEvent('touchstart');

        this.addDocumentEvent('touchmove', this.onMouseMove.bind(this));
        this.addDocumentEvent('mousemove', this.onMouseMove.bind(this));
        this.addDocumentEvent('mouseup',this.onMouseUp.bind(this))
        this.addDocumentEvent('touchend',this.onMouseUp.bind(this))
        //this.addDocumentEvent('mouseout',this.onMouseUp.bind(this))

        let clientX = e.clientX;
        let clientY = e.clientY;
        if(e.type == 'touchstart'){
            clientX = e.targetTouches[0].clientX
            clientY = e.targetTouches[0].clientY
        }

        this.startX = clientX - this.elem.getBoundingClientRect().left;
        this.startY = clientY - this.elem.getBoundingClientRect().top;
    }

    onMouseMove(e){
        let pageX = e.clientX
        let pageY = e.clientY


        if(e.type == 'touchmove'){
            pageX = e.targetTouches[0].clientX
            pageY = e.targetTouches[0].clientY
        }
        this.moveElement(pageX, pageY)
    }

    onMouseUp(){
        this.setCursorStyle('grab');
        //this.removeEvent('mouseout');
        this.removeDocumentEvent('mouseup');
        this.removeDocumentEvent('mousemove');
        this.removeDocumentEvent('touchend');
        this.removeDocumentEvent('touchmove');
        this.addEvent('touchstart', this.onMouseDown.bind(this));
        this.addEvent('mousedown', this.onMouseDown.bind(this));
    }

    destroy() {
        this.removeEvent('mouseout');
        this.removeEvent('mouseup');
        this.removeEvent('mousemove');
        this.removeEvent('mousedown');
        this.removeEvent('touchstart');
    }


    addEvent(action, callback){
        this.removeEvent(action)
        this.handlers[action] = callback;
        this.elem.addEventListener(action, this.handlers[action])
    }

    removeEvent(action){
        if(this.handlers[action])
            this.elem.removeEventListener(action, this.handlers[action])
    }

    addDocumentEvent(action, callback){
        this.removeEvent(action)
        this.handlers[action] = callback;
        document.addEventListener(action, this.handlers[action])
    }

    removeDocumentEvent(action){
        if(this.handlers[action])
        document.removeEventListener(action, this.handlers[action])
    }

    setCursorStyle(cursorStyle){
        //this.elem.style.cursor = cursorStyle;
    }

    moveElement(pageX, pageY){
        this.elem.style.left = pageX - this.startX + 'px'
        this.elem.style.top = pageY - this.startY + 'px'
    }

    blockTarget(e){
        if(!this.dragTargets.length){
            return false;
        }

        let block = true;
        this.dragTargets.forEach( rule => {
            if(e.target.classList.contains(rule)){
                block = false;
            }
        })
        return block;
    }

}